import {Component, EventEmitter, Input, Output} from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import 'firebase/firestore';
import {AsyncPipe, NgClass, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {getAuth} from "firebase/auth";
import {addDoc, collection, Firestore} from "@angular/fire/firestore";
import {Router, RouterLink} from "@angular/router";
import {TeacherService} from "../services/teacher.service";
import {Event} from "../interfaces/event";
import {Teacher} from "../interfaces/teacher";
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-events-form',
  templateUrl: './events-form.component.html',
  standalone: true,
  imports: [
    AsyncPipe,
    FormsModule,
    NgIf,
    NgClass,
    RouterLink
  ],
  styleUrl: './events-form.component.css'
})
export class EventsFormComponent {
  @Input() isEditMode: boolean = false;
  @Input() eventId?: string;
  now = new Date();
  teacher: Teacher | null = null;

  formData: Event = {
    status: '',
    name: '',
    startDate: '',
    endDate: '',
    webLink: '',
    description: '',
    contactPhone: '',
    commentary: '',
    createdBy: '',
    creationDate: '',
    updatedBy: '',
    updatedDate: '',
    isDeleted: false,
    contactName: ''
  };
  @Output() formSubmitted = new EventEmitter<Event>();

  constructor(public afAuth: AngularFireAuth, private firestore: Firestore, private router: Router, private teacherService: TeacherService) {}

  protected readonly onclick = onclick;
  protected readonly String = String;

  async ngOnInit(){
    this.teacher = await this.teacherService.getTeacher();

  }

  initializeForm(event: Event) {
    const currentTime = new Date().toISOString();
    this.formData = {
      ...event,
      creationDate: currentTime,
      updatedDate: currentTime,
    };
  }

  allowNumbersOnly(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) return;
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  async submitForm() {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert('You must be logged in to submit this form.');
      return;
    }

    try {
      if (
        this.formData.startDate &&
        this.formData.endDate &&
        new Date(this.formData.startDate) > new Date(this.formData.endDate)
      ) {
        alert('The starting date cannot be after the ending date.');
        return;
      }

      const formCollection = collection(this.firestore, 'event');
      const currentTime = new Date().toISOString();
      const teacherName = `${this.teacher?.fName ?? ''} ${this.teacher?.lName ?? ''}`.trim();

      const dataToSave: any = {
        ...this.formData
      };

      if (this.isEditMode && this.eventId) {
        const docRef = firebase.firestore().collection('event').doc(this.eventId);
        const existingDoc = await docRef.get();

        if (existingDoc.exists) {
          const existingData = existingDoc.data();

          dataToSave['createdBy'] = existingData?.['createdBy'];
          dataToSave['creationDate'] = existingData?.['creationDate'];
        }

        dataToSave['updatedBy'] = teacherName;
        dataToSave['updatedDate'] = currentTime;

        await docRef.update(dataToSave);

        alert('Event updated successfully!');
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([`/events/${this.eventId}`]);
        });

      } else {
        dataToSave['createdBy'] = teacherName;
        dataToSave['creationDate'] = currentTime;

        dataToSave['updatedBy'] = teacherName;
        dataToSave['updatedDate'] = currentTime;

        const docRef = await addDoc(formCollection, dataToSave);

        alert('Form submitted successfully!');
        this.router.navigate([`/events/${docRef.id}`]);
      }

    } catch (error: any) {
      console.error(error);
      alert(`Error submitting form: ${error.message}`);
    }
  }
}
